import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/consulting",
    name: "consulting",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/consultingView.vue"),
  },
  {
    path: "/course",
    name: "course",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/courseView.vue"),
  },
  {
    path: "/source",
    name: "source",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/sourceView.vue"),
  },
  {
    path: "/examination",
    name: "examination",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/examinationView.vue"),
  },
  {
    path: "/jianli",
    name: "jianli",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/jianliView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
